import Icon from '@ant-design/icons';
import { COLORS } from '@constants';
import styled, { css } from 'styled-components';

const normalizeStrokeWidth = (value) => {
    if (value === undefined || value === null) {
        return 'inherit';
    }

    if (typeof value === 'number') {
        return `${value}px`;
    }

    if (typeof value === 'string') {
        const trimmed = value.trim();
        if (trimmed === '') {
            return 'inherit';
        }
        const hasUnit = /^[\d.]+(px|em|rem|%|ex|ch|vw|vh|vmin|vmax|cm|mm|in|pt|pc)$/i.test(trimmed);
        return hasUnit || /^[\d.]+$/.test(trimmed) ? trimmed : 'inherit';
    }

    return 'inherit';
};

export const StyledIcon = styled(Icon)`
    color: ${({ $color }) => $color || COLORS.$white};
    font-size: ${({ $size }) => $size};
    position: relative;
    ${({ $stroke }) => $stroke && `stroke: ${$stroke};`}
    ${({ $cursor }) => $cursor && `cursor: ${$cursor};`}

    path {
        ${({ $fill }) => $fill && `fill: ${$fill};`}
    }

    svg {
        --stroke-width: ${({ $strokeWidth }) => normalizeStrokeWidth($strokeWidth)};

        path {
            stroke-width: var(--stroke-width, inherit);
        }
    }

    & > * {
        z-index: 2;
        position: relative;
    }

    &.ant-spin-dot {
        font-size: ${({ $size }) => $size};
    }

    ${({ $roundedSize }) =>
        $roundedSize &&
        css`
            cursor: pointer;

            &::after {
                transition: all 0.2s ease-in;
                height: ${({ $roundedSize }) => $roundedSize};
                width: ${({ $roundedSize }) => $roundedSize};
                outline: 2px solid ${({ $outlineColor }) => $outlineColor};
                outline-offset: -2px;
                top: 50%;
                left: 50%;
                transform: translate3d(-50%, -50%, 0);

                content: '';
                position: absolute;
                border-radius: 50%;
                z-index: 1;
                background-color: ${({ $roundedColor }) => $roundedColor || 'transparent'};
                opacity: ${({ $roundedOpacity }) => $roundedOpacity || 1};
            }

            &:hover:after {
                background-color: ${({ $hoverRoundedColor }) => $hoverRoundedColor || 'transparent'};
            }
        `};
`;
